const items = [
  {
    id: 'faq-1',
    q: '网红爆料的爆料信息来源是否可靠？',
    a: '我们建立了严格的信息核实机制。每一条爆料内容均来源于公开信息、当事人社交账号、媒体报道或可信投稿，并经过编辑团队的交叉验证。对于未经证实的传闻，我们会明确标注"待核实"标签，绝不传播虚假信息。',
  },
  {
    id: 'faq-2',
    q: '如何向网红爆料投稿或提供线索？',
    a: '您可以通过页面底部的"联系我们"区域获取投稿联系方式。我们欢迎广大网友提供真实、有据可查的爆料线索。所有投稿信息将严格保密，投稿人身份不会在未经授权的情况下公开。',
  },
  {
    id: 'faq-3',
    q: '网站上的内容多久更新一次？',
    a: '我们保持全天候滚动更新机制。编辑团队7x24小时监测各大社交平台和新闻渠道，确保在网红爆料事件发生后的最短时间内发布相关报道。重大事件通常在事发后1小时内上线初步报道，并持续跟进最新进展。',
  },
  {
    id: 'faq-4',
    q: '平台上的网红八卦内容是否会侵犯个人隐私？',
    a: '我们严格遵循内容合规原则。所有报道仅限于公众人物的公开言行、商业活动和社交媒体内容，不涉及个人隐私信息。对于涉及法律纠纷的报道，我们会在司法机关做出最终裁决后及时更新案件结果，确保信息准确完整。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">常见问答</h2>
        </div>

        <div className="space-y-3">
          {items.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg border border-secondary-200/60 p-5 md:p-6">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold">Q</span>
                <span>{item.q}</span>
              </h3>
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center text-xs font-bold">A</span>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}